(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kletskop-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kletskop-gallery')) {
  customElements.define('kletskop-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.photos = this.getPhotos();
      this.position = 0;
      Array.from(this.querySelectorAll('.kg-photo')).forEach(photo => photo.addEventListener('click', () => {
        this.photos = this.getPhotos();
        this.position = this.photos.indexOf(photo);
        this.updatePhoto();
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
      }));
      this.querySelector('.kg-close').addEventListener('click', () => this.dialog.close());
      this.querySelector('.kg-prev').addEventListener('click', () => this.move(-1));
      this.querySelector('.kg-next').addEventListener('click', () => this.move(1));
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.move(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); this.move(1); }
      });
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog) {
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }
      });
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        this.photos[this.position]?.focus();
      });
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        document.body.style.overflow = this.previousOverflow || '';
      }
    }
    getPhotos() {
      if (!this.dataset.galleryGroup) return Array.from(this.querySelectorAll('.kg-photo'));
      return Array.from(document.querySelectorAll('kletskop-gallery')).filter(gallery => gallery.dataset.galleryGroup === this.dataset.galleryGroup).flatMap(gallery => Array.from(gallery.querySelectorAll('.kg-photo')));
    }
    move(step) {
      this.position = (this.position + step + this.photos.length) % this.photos.length;
      this.updatePhoto();
    }
    updatePhoto() {
      const photo = this.photos[this.position];
      const image = this.querySelector('.kg-large');
      image.src = photo.dataset.full;
      image.alt = photo.querySelector('img').alt;
      this.querySelector('.kg-caption').textContent = photo.dataset.caption;
      const link = this.querySelector('.kg-link');
      link.hidden = !photo.dataset.link;
      if (photo.dataset.link) link.href = photo.dataset.link;
      else link.removeAttribute('href');
      link.textContent = photo.dataset.label || 'Bekijk dit artikel';
      this.querySelector('.kg-prev').hidden = this.photos.length < 2;
      this.querySelector('.kg-next').hidden = this.photos.length < 2;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
